import "./GetMoreInfo.css";

import icon1 from "../../assets/image/01.svg";
import icon2 from "../../assets/image/02.svg";
import icon3 from "../../assets/image/03.svg";

export default function GetMoreInfo() {
  return (
    <section className="fs-info-section">
      <div className="container">
        {/* Title */}
        <div className="row mb-4">
          <div className="col text-center">
            <h2 className="fs-info-title">Get more Information</h2>
            <p className="fs-info-subtitle">
              We offer prompt response via telephone and email. You will receive
              a reply within 12 hours. Or chat with us now for an immediate reply!
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <a href="#" className="fs-info-card">
              <div className="fs-info-icon">
                <img src={icon1} alt="Project Inquiry" />
              </div>
              <div className="fs-info-text">
                <h6>Project Inquiry</h6>
                <p>Customized technical support to meet different requests.</p>
              </div>
            </a>
          </div>

          <div className="col-lg-4 col-md-6">
            <a href="#" className="fs-info-card">
              <div className="fs-info-icon">
                <img src={icon2} alt="Contact Sales" />
              </div>
              <div className="fs-info-text">
                <h6>Contact Sales</h6>
                <p>
                  Contact our sales team for products and solutions inquiries.
                </p>
              </div>
            </a>
          </div>

          <div className="col-lg-4 col-md-6">
            <a href="#" className="fs-info-card">
              <div className="fs-info-icon">
                <img src={icon3} alt="Online Chat" />
              </div>
              <div className="fs-info-text">
                <h6>Online Chat</h6>
                <p>Chat with our live agent for general inquiries now.</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
